export const placeStyles = {
  wrapper: {
    textAlign: "center",
    alignItems: "center",
    justifyContent: "center",
    my: {
      mobile: "1.5rem",
      laptop: "0",
    },
    width: {
      laptop: "21.875rem",
    },
  },
  container: {
    borderRadius: "100%",
    maxWidth: "12.625rem",
    maxHeight: "12.625rem",
    margin: {
      mobile: "0 auto 3rem",
    },
  },
  imageWrapper: {
    position: "absolute",
    zIndex: "-1",
  },
  heading: {
    mb: "2rem",
    textTransform: "uppercase",
  },
};
